// src/hooks/useTimeZone
import { useRef } from 'react'
import moment from 'moment-timezone'
import { useTimezoneSelect, allTimezones } from 'react-timezone-select'
import { getTimeZones } from '../../../utils/common'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useTimeZone = (customTimeZone) => {
  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })

  const currentTimeZone = customTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone
  const zoneAbbr = useRef(moment().tz(currentTimeZone).zoneAbbr())
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const zoneAbbrString = parseTimezone(currentTimeZone).label

  return {
    currentTimeZone,
    zoneAbbr,
    zoneAbbrString,
  }
}
